export const contactsData = {
    email: 'lindelanimcebo@gmail.com',
    phone: '0616788448',
    address: 'Some Where in Cape Town, South Africa - 7700 ',

    sheetAPI: ''
}